/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_Cep_Not_FoundInputs */

const en_clients_field_address_cep_not_found = /** @type {(inputs: Clients_Field_Address_Cep_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEP not found.`)
};

const pt_br2_clients_field_address_cep_not_found = /** @type {(inputs: Clients_Field_Address_Cep_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CEP não encontrado.`)
};

/**
* | output |
* | --- |
* | "CEP not found." |
*
* @param {Clients_Field_Address_Cep_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_cep_not_found = /** @type {((inputs?: Clients_Field_Address_Cep_Not_FoundInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_Cep_Not_FoundInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_cep_not_found(inputs)
	return pt_br2_clients_field_address_cep_not_found(inputs)
});